// 10    50
// 12    100
// 15    200
// 20    250    银卡
// 23    300
// 30    500    金卡
// 38    1500
// 40    2000    钻卡
let selectLevel2TotalFcMap = {};
let totalFc2SelectLevelMap = {};
let levelInfoListShow = [];

const levelInfoList = [
  {
    id: 0,
    selectlevel: 0,
    totalFc: 0,
    label: "",
    translateKey: "",
    isShow: false,
  },
  {
    id: 1,
    selectlevel: 10,
    totalFc: 50,
    label: "",
    translateKey: "",
    isShow: false,
  },
  {
    id: 2,
    selectlevel: 12,
    totalFc: 100,
    label: "",
    translateKey: "",
    isShow: false,
  },
  {
    id: 3,
    selectlevel: 15,
    totalFc: 200,
    label: "",
    translateKey: "",
    isShow: false,
  },
  {
    id: 4,
    selectlevel: 20,
    totalFc: 250,
    label: "银卡",
    translateKey: "",
    isShow: true,
  },
  {
    id: 5,
    selectlevel: 23,
    totalFc: 300,
    label: "",
    translateKey: "",
    isShow: false,
  },
  {
    id: 6,
    selectlevel: 30,
    totalFc: 500,
    label: "金卡",
    translateKey: "",
    isShow: true,
  },
  {
    id: 7,
    selectlevel: 38,
    totalFc: 1500,
    label: "",
    translateKey: "",
    isShow: false,
  },
  {
    id: 8,
    selectlevel: 40,
    totalFc: 2000,
    label: "钻卡",
    translateKey: "",
    isShow: true,
  },
];

levelInfoList.forEach((item) => {
  selectLevel2TotalFcMap[item.selectlevel] = item.totalFc;
  totalFc2SelectLevelMap[item.totalFc] = item.selectlevel;
});

levelInfoListShow = levelInfoList.filter((item) => item.isShow);
let levelRules = [];

for (let i = 0; i < levelInfoListShow.length + 1; i++) {
  if (i === 0) {
    levelRules.push({
      selectlevel: 0,
      min: 0,
      max: levelInfoListShow[i].totalFc,
    });
  } else if (i === levelInfoListShow.length) {
    levelRules.push({
      selectlevel: levelInfoListShow[i - 1].selectlevel,
      min: levelInfoListShow[i - 1].totalFc,
      max: Infinity,
    });
  } else {
    levelRules.push({
      selectlevel: levelInfoListShow[i - 1].selectlevel,
      min: levelInfoListShow[i - 1].totalFc,
      max: levelInfoListShow[i].totalFc,
    });
  }
}

// Example of levelRules structure
// [
//     {
//         "selectlevel": 0, // 0不允许
//         "min": 0,
//         "max": 250
//     },
//     {
//         "selectlevel": 20,
//         "min": 250, // 最低pv值
//         "max": 500
//     },
//     {
//         "selectlevel": 30,
//         "min": 500,
//         "max": 2000
//     },
//     {
//         "selectlevel": 40,
//         "min": 2000,
//         "max": null
//     }
// ]

export {
  levelInfoList, // 全部级别pv值
  levelInfoListShow, // 显示的级别pv值
  selectLevel2TotalFcMap, // 级别对应的pv值
  totalFc2SelectLevelMap, // pv值对应的级别
  levelRules, // pv值级别判断规则
};
